import { LANGUAGES } from '../constants/languages';
import i18n from 'i18next';
import classNames from 'classnames';
import { FunctionComponent } from 'react';

const LanguageSwitcher: FunctionComponent = () => {
  return (
    <>
      {Object.keys(LANGUAGES).map((language, index) => (
        <div
          onClick={() => i18n.changeLanguage(language)}
          className={classNames(
            'px-1 cursor-pointer text-[15px] hover:text-theme-main ',
            { 'font-bold': i18n.resolvedLanguage === language },
            { 'border-r': Object.keys(LANGUAGES).length - 1 !== index },
          )}
          key={language}
          lang={language}
          title={LANGUAGES[language].nativeName}
        >
          {LANGUAGES[language].short}
        </div>
      ))}
    </>
  );
};

export default LanguageSwitcher;
